import { getHeaders, getQueryString, SubmissionURL } from './config';
import { checkStatus, getAll, getData, getRawData } from './normalizer';
import { setTypes } from '../helpers/typeHelper';
import { RestoreLocationsRequest } from '../types/underwriting.type';

export const getLocationDetails = async (id: string, includeProximity?: boolean, productLineCode?: string) => {
    const qs = getQueryString({ includeProximity, productLineCode });
    return fetch(`${SubmissionURL}/location/${id}${qs}`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then(getRawData)
        .then(setTypes);
};

export const updateLocationInspection = async (id: string, payload: any) => {
    return fetch(`${SubmissionURL}/location/${id}/inspections`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify(payload),
    })
        .then(checkStatus)
        .then(getData);
};

export const fetchLocationInspections = async (id: string) => {
    return fetch(`${SubmissionURL}/location/${id}/inspections`, {
        method: 'GET',
        headers: getHeaders(),
    })
        .then(checkStatus)
        .then(getAll);
};

export const updateBetterviewUrl = async (id: number, betterviewUrl: string) => {
    return fetch(`${SubmissionURL}/location/${id}/betterview-url`, {
        method: 'POST',
        headers: getHeaders(),
        body: JSON.stringify({ betterviewUrl: betterviewUrl }),
    }).then(checkStatus);
};
